import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/logo.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as InstagramIcon } from "../../images/instagram-logo.svg";
import { ReactComponent as GithubIcon } from "../../images/github-icon.svg";
import { Link } from "react-router-dom";

const Container = tw(ContainerBase)`bg-gray-200 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const LinkText = tw.p`border-b-2 border-transparent hocus:text-primary-500 hocus:border-primary-500 pb-1 transition duration-300 mt-2 mx-4`;
const SubtextLink = tw.a`border-b-2 border-transparent hocus:text-primary-500 hocus:border-primary-500 pb-1 transition duration-300`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-700 text-gray-100 hover:bg-gray-900 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} alt={'Revise Higher website logo'} />
            <LogoText>Revise Higher</LogoText>
          </LogoContainer>
          <LinksContainer>
            <Link to='/'><LinkText>Home</LinkText></Link>
            {/* <Link href="/about">About</Link> */}
            <Link to='/subjects'><LinkText>Subjects</LinkText></Link>
            <Link to='/subjects/maths'><LinkText>Maths</LinkText></Link>
            <Link to='/privacy-policy'><LinkText>Privacy Policy</LinkText></Link>
            <Link to='/terms-of-service'><LinkText>Terms of Service</LinkText></Link>
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink href="https://twitter.com/ach_henderson" alt="Follow @ach_henderson on Twitter">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://github.com/angushenderson" alt="Follow @angushenderson on Github">
              <GithubIcon />
            </SocialLink>
            <SocialLink href="https://www.instagram.com/angus.henderson_/" alt="Follow @angus.henderson_ on Instagram">
              <InstagramIcon />
            </SocialLink>
          </SocialLinksContainer>
          <CopyrightText>
            Contact: <SubtextLink href='mailto:angus@revisehigher.com'>angus@revisehigher.com</SubtextLink>
            <br /><br />
            Images: <SubtextLink href='https://unsplash.com/'>Unsplash</SubtextLink>. Design: <SubtextLink href='https://treact.owaiskhan.me/'>Treact</SubtextLink>. <SubtextLink href='/sitemap.xml'>Sitemap</SubtextLink>.
          </CopyrightText>
        </Row>
      </Content>
    </Container >
  );
};